(() => {
  'use strict';

  const switchers = document.querySelectorAll('[data-region-switcher]');
  if (!switchers.length) return;

  const closeSwitcher = (switcher, restoreFocus = false) => {
    if (!switcher.open) return;
    switcher.open = false;
    if (restoreFocus) switcher.querySelector('summary')?.focus();
  };

  switchers.forEach((switcher) => {
    const tabsContainer = switcher.querySelector('[data-region-tabs]');
    const tabs = Array.from(switcher.querySelectorAll('[data-region-tab]'));
    const panels = Array.from(switcher.querySelectorAll('[data-region-panel]'));
    const form = switcher.querySelector('form');
    const apply = switcher.querySelector('[data-region-apply]');
    const close = switcher.querySelector('[data-region-close]');
    if (!tabsContainer || !tabs.length || !panels.length || !form || !apply) return;

    switcher.dataset.enhanced = 'true';
    tabsContainer.setAttribute('role', 'tablist');

    const panelFor = (group) => panels.find((panel) => panel.dataset.regionPanel === group);
    const groupHasCountries = (group) => Number(panelFor(group)?.dataset.countryCount ?? 0) > 0;
    const checkedGroup = () => form.querySelector('input[name="country_code"]:checked')?.closest('[data-region-panel]')?.dataset.regionPanel ?? '';

    const activate = (group, focusTab = false) => {
      const activeTab = tabs.find((tab) => tab.dataset.regionTab === group) ?? tabs[0];
      const activeGroup = activeTab.dataset.regionTab;

      tabs.forEach((tab) => {
        const selected = tab === activeTab;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        const selected = panel.dataset.regionPanel === activeGroup;
        panel.setAttribute('role', 'tabpanel');
        panel.hidden = !selected;
      });

      const selectedInPanel = panelFor(activeGroup)?.querySelector('input[name="country_code"]:checked');
      apply.disabled = !groupHasCountries(activeGroup) || !selectedInPanel;
      if (focusTab) activeTab.focus();
    };

    const initialGroup = checkedGroup()
      || switcher.dataset.initialGroup
      || tabs.find((tab) => groupHasCountries(tab.dataset.regionTab))?.dataset.regionTab
      || tabs[0].dataset.regionTab;
    activate(initialGroup);

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.regionTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let targetIndex = index;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = tabs.length - 1;
        activate(tabs[targetIndex].dataset.regionTab, true);
      });
    });

    form.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'country_code') return;
      const group = event.target.closest('[data-region-panel]')?.dataset.regionPanel;
      if (group) activate(group);
    });

    form.addEventListener('submit', (event) => {
      const activePanel = panels.find((panel) => !panel.hidden);
      if (!activePanel?.querySelector('input[name="country_code"]:checked')) {
        event.preventDefault();
        return;
      }
      const returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    });

    close?.addEventListener('click', () => closeSwitcher(switcher, true));
    switcher.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeSwitcher(switcher, true);
    });
  });

  document.addEventListener('pointerdown', (event) => {
    switchers.forEach((switcher) => {
      if (switcher.open && !switcher.contains(event.target)) closeSwitcher(switcher);
    });
  });
})();
